"use client";
import { Box, SimpleGrid } from "@chakra-ui/react";
import { useAtomValue } from "jotai";
import { postsControllerAtom } from "../filter-bar/use-posts-filter";
import PostCard, { PostPreview } from "./card";
import { KCTrending } from "./trending";

export interface PostViewProps {
  posts: PostPreview[];
  filtered?: PostPreview[];
  // Determines whether this is a tag page or not.
  tag: boolean;
}

export const PostView = ({
  posts,
  filtered,
  tag,
  color,
}: PostViewProps & { color?: string }) => {
  const postController = useAtomValue(postsControllerAtom);
  const rest = posts.filter((post) => !post.trending);
  return (
    <Box
      maxW={{ base: "xl", md: "2xl", lg: "7xl" }}
      mx="auto"
      pb="24"
      position="relative"
    >
      {(postController.filter === "All" &&
        !postController.search &&
        postController.sort === "Sort") ||
      tag ? (
        <>
          <KCTrending posts={posts} color={color} />
          <SimpleGrid
            justifyContent="center"
            mt={20}
            columns={{ base: 1, lg: 3 }}
            spacing="14"
            px={{ base: "6", md: "8" }}
          >
            {rest.map((post, i) => (
              <PostCard key={i} {...{ post }} color={color} />
            ))}
          </SimpleGrid>
        </>
      ) : (
        <>
          <SimpleGrid
            justifyContent="center"
            mt={20}
            columns={{ base: 1, lg: 3 }}
            spacing="14"
            px={{ base: "6", md: "8" }}
          >
            {filtered?.map((post, i) => (
              <PostCard key={i} {...{ post }} color={color} />
            ))}
          </SimpleGrid>
          <KCTrending posts={posts} />
        </>
      )}
    </Box>
  );
};

export default PostView;
